import CloseIcon from "@mui/icons-material/Close";
import CloseFullscreen from "@mui/icons-material/CloseFullscreen";
import MinimizeIcon from "@mui/icons-material/Minimize";
import OpenInFull from "@mui/icons-material/OpenInFull";
import { IconButton, Stack, Typography } from "@mui/material";

import { useFullScreen } from "../../utils/dialog";
import { AvaIcon } from "../Ava/Messenger/AvaIcon";
import { useAvaCaseIQContext } from "./AvaCaseIQProvider";
import { useAvaContext } from "./AvaContext";
import { useAvaDialogContext } from "./AvaDialogContextProvider";
import { MoreOptionsMenu } from "./MoreOptionsMenu";

type Props = {
  readonly onCloseClicked: () => void;
};

export const ChatToolbarHeader = ({ onCloseClicked }: Props) => {
  const { changeFullscreenMode, isFullscreenMode, setIsAvaDialogMinimized } = useAvaDialogContext();
  const { caseIQConversationId } = useAvaCaseIQContext();
  const { conversationId } = useAvaContext();
  const { isMobile } = useFullScreen("sm");

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        pl: 2,
        pr: 1,
        width: "100%",
      }}
    >
      <Stack direction="row" spacing={1} py={2}>
        <AvaIcon />
        <Typography variant="subtitle1" fontWeight={500} data-cy="ava-by-doit-cloud-intelligence">
          Support by DoiT Cloud Intelligence™
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center">
        {!isFullscreenMode && conversationId && !caseIQConversationId && (
          <MoreOptionsMenu conversationId={conversationId} isSideChatMenu />
        )}
        <IconButton
          onClick={() => {
            setIsAvaDialogMinimized(true);
          }}
        >
          <MinimizeIcon />
        </IconButton>
        {!isMobile && (
          <IconButton
            onClick={() => {
              changeFullscreenMode(!isFullscreenMode);
            }}
          >
            {isFullscreenMode ? <CloseFullscreen /> : <OpenInFull />}
          </IconButton>
        )}
        <IconButton onClick={onCloseClicked}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
};
